import React from 'react';

import { LoadingButton } from '@mui/lab';
import { DialogActions, Button } from '@mui/material';

export const FormFooter = ({ loading = false, nextLabel = 'Next', isValid, onBack, onNext }) => (
  <DialogActions>
    <Button onClick={onBack} size="large" variant="outlined" sx={{ width: '30%' }}>
      Back
    </Button>
    <LoadingButton
      loading={loading}
      sx={{ width: '70%' }}
      color="primary"
      variant="contained"
      onClick={() => onNext()}
      disabled={!isValid}
      size="large"
      fullWidth
    >
      {nextLabel}
    </LoadingButton>
  </DialogActions>
);
